export class ValidatorMessage {
    public type: string;
    public message: string;

    constructor(type: string, message: string) {
        this.type = type;
        this.message = message;
    }
}

export const ValidationTypes = {
    cpqNoWhiteSpace: 'cpqNoWhiteSpace',
    cpqEmail: 'cpqEmail',
    cpqDate: 'cpqDate',
    cpqAlphaNumeric: 'cpqAlphaNumeric',
    cpqPassword: 'cpqPassword',
    cpqPasswordMatching: 'cpqPasswordMatching',
    cpqRequired: 'cpqRequired',
    cpqNumber: 'cpqNumber',
    cpqBlockedUser: 'cpqBlockedUser',
    cpqURL: 'cpqURL',
    cpqCustomValidation: 'cpqCustomValidation',
    cpqCannotStartWithWhiteSpace: 'cpqCannotStartWithWhiteSpace',
};
